// extracted by mini-css-extract-plugin
module.exports =  {"beta_withBackground":"InlineMessageBeta-module__beta_withBackground___IqD83","beta__icon":"InlineMessageBeta-module__beta__icon___l_9aQ"};